import { ExpensesCalculatorData } from "../api";
import { RuntimeLocaleKey, useFormatMessage } from "../../../../intl";
import { Dialog } from "@dbn/omnichannel-design-system-g4p";
import { option } from "fp-ts";
import { ExpensesCalculator } from "./ExpensesCalculator";
import { ExpensesCalculatorProvider } from "./ExpensesCalculatorProvider";

type Props = {
  onCancel: () => unknown;
  onSaved: () => unknown;
  calculatorData: ExpensesCalculatorData;
};

export function ExpensesCalculatorDialog(props: Props) {
  const formatMessage = useFormatMessage();

  return (
    <Dialog
      ariaLabelMessageForCloseIcon={formatMessage(
        "Modal.closeButton" as RuntimeLocaleKey
      )}
      title={formatMessage(
        "StandardLoan.ExpensesConfirmation.Calculator.Form.title"
      )}
      size="small"
      actions={[]}
      onDismiss={option.some(props.onCancel)}
      variant="left"
    >
      <ExpensesCalculatorProvider initialExpenses={props.calculatorData}>
        <ExpensesCalculator
          onSaved={props.onSaved}
          onCancel={props.onCancel}
          data={props.calculatorData}
        />
      </ExpensesCalculatorProvider>
    </Dialog>
  );
}
